import React from 'react';
import HelpIcon from './HelpIcon';

const CheckboxInput = ({ label, name, register, align = 'left', sx = {}, helptext }) => (
  <div className="form-group checkbox-group" style={{ textAlign: align }}>
    <label>
      <input type="checkbox" style={sx} {...register(name)} />
      {label}
      <HelpIcon helptext={helptext} />
    </label>
  </div>
);

export default CheckboxInput;
